<template>
    <div class="fill-height">

        <v-progress-linear
                :active="inLoading"
                :indeterminate="inLoading"
                absolute
                color="deep-purple-accent-4"
        ></v-progress-linear>

        <v-snackbar color="error" location="top" v-model="snackbarError" :timeout="15000">
            <span>{{ message }}</span>
            <template v-slot:actions>
                <v-btn variant="text" @click="snackbarError = false">{{ $t('close') }}</v-btn>
            </template>
        </v-snackbar>

        <v-snackbar color="success" location="top" v-model="snackbarSuccess" :timeout="15000">
            <span>{{ message }}</span>
            <template v-slot:actions>
                <v-btn variant="text" @click="snackbarSuccess = false">{{ $t('close') }}</v-btn>
            </template>
        </v-snackbar>

        <v-container class="fill-height" fluid>
            <v-row align="center" justify="center">
                <v-col cols="12" sm="8" md="4">
                    <v-card class="elevation-12">

                        <v-card-text>
                            <v-form ref="form">

                                <v-text-field
                                        ref="email"
                                        :label="$t('enterYourEmail')"
                                        name="email"
                                        type="text"
                                        variant="outlined"
                                        :rules="emailRules"
                                        required
                                        v-model="email"
                                        :disabled='isSuccess'
                                ></v-text-field>

                                <v-btn color="success" style="min-height: 50px" block @click="sendPasswordUpdateEmail()" :disabled='inProgress || inLoading'>
                                    {{ $t('sendPasswordUpdateEmail') }}
                                </v-btn>

                            </v-form>
                        </v-card-text>
                    </v-card>

                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>

    import api from './backend-api'
    import { useI18n } from 'vue-i18n'

    export default {
        name: "ForgotPassword",
        setup() {
            const { t } = useI18n();
            return { t };
        },
        data() {
            return {
                email: '',
                message: '',
                snackbarError: false,
                snackbarSuccess: false,
                inProgress: false,
                inLoading: false,
                isSuccess: false,
                emailRules: [
                    v => !!v || this.t('emailRequired'),
                ],
            }
        },
        methods: {
            async sendPasswordUpdateEmail(){
                this.inProgress = true;
                this.inLoading = true;
                const { valid } = await this.$refs.form.validate();
                    if (!valid) {
                        this.inProgress = false;
                        this.inLoading = false;
                    } else {
                        api.sendPasswordUpdateEmail(this.email)
                            .then(response => {
                                if (response.data.success) {
                                    this.isSuccess = true;
                                    this.message = response.data.message;
                                    this.snackbarSuccess = true;
                                    this.inLoading = false;
                                } else {
                                    this.inProgress = false;
                                    this.inLoading = false;
                                    this.message = response.data.message;
                                    this.snackbarError = true;
                                }
                            })
                            .catch(error => {
                                console.log(error);
                                this.message = this.t('connectionLost');
                                this.snackbarError = true;
                                this.inProgress = false;
                                this.inLoading = false;
                            })
                    }
            }
        }
    }
</script>

<style scoped>

</style>